<template></template>

<script>
export default {
  name: "update"
};
</script>

<style scoped>
</style>